import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'

import Button from 'components/Button'
import content from 'prismic-translates/dialog-legals-modal.json'
import { useAppDispatch } from 'store/hooks'
import { logOut } from 'store/modules/auth/actions'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  size?: 'small' | 'large'
  className?: string
  label?: string
  onClick?: () => void
}

export const LogoutButton = ({ className, onClick, label, size = 'small' }: Props) => {
  const dispatch = useAppDispatch()
  const onLogOut = () => dispatch(logOut())

  return (
    <Button size={size} onClick={onClick || onLogOut} className={cx(classes.logoutBtn, className)} variant='contained'>
      {label || t('logout')}
    </Button>
  )
}
